var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fs-adjustments"},[_c('fs-range-filter-wrapper',{attrs:{"routerLink":'/adjustments',"min":"-1","max":"1","defaultValue":"0","label":"menu.saturation"},model:{value:(_vm.value.saturation),callback:function ($$v) {_vm.$set(_vm.value, "saturation", $$v)},expression:"value.saturation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }